/**
 * 明細テーブルのセル input に適用する共通クラス。
 * `hasError=true` で赤枠＋薄赤背景＋赤リング。
 *
 * 通常時は bg-transparent にして「行の色分け(<tr>/<td> の stripe)」を input まで透過させる
 * （白背景だと p-0 の td を input が覆い、行の色が見えなくなるため）。
 * 入力中は focus:bg-white で対象セルを白くして編集箇所を明確にする。
 */
export function detailCellInputClass(hasError: boolean): string {
  const base =
    'w-full min-w-0 box-border text-xs text-gray-900 border rounded px-1.5 py-1 m-0.5 focus:ring-1 focus:border-blue-400'
  return hasError
    ? `${base} border-red-500 bg-red-50 ring-1 ring-red-300 focus:ring-red-500`
    : `${base} border-gray-200 bg-transparent focus:bg-white focus:ring-blue-500`
}

// ── 明細テーブル 左側固定列（受給者 編集/詳細 で共用）──────────────────
// No. 列 + データ先頭4列(f1 世帯識別符号 / f2 計算開始(年) / f3 (月) / f4 (日)) を
// 横スクロール時も左に固定する。No.列の sticky を f1〜f4 へ横展開するだけ。
// left は固定列幅の累積: No.=48px(w-12), データ列=104px(w-[6.5rem])。
// Tailwind JIT が拾えるよう left クラスは静的文字列で列挙する(動的生成だと未生成になる)。
export const FROZEN_DATA_COL_COUNT = 4;
export const FROZEN_LEFT_CLASS = ['left-[48px]', 'left-[152px]', 'left-[256px]', 'left-[360px]'] as const;
export const isFrozenDataCol = (colIdx: number) => colIdx < FROZEN_DATA_COL_COUNT;
export const isLastFrozenDataCol = (colIdx: number) => colIdx === FROZEN_DATA_COL_COUNT - 1;
